import React, { useEffect, useState } from "react";

export default function NumberInput({ value, onChange, placeholder }) {
  const [inputValue, setInputValue] = useState(value ? String(value) : "");

  const handleChange = (e) => {
    const val = e.target.value;

    // chỉ cho phép nhập số
    if (/^\d*$/.test(val)) {
      setInputValue(val);

      if (onChange) {
        // nếu rỗng thì trả về "", nếu có thì trả về số
        onChange(val === "" ? "" : Number(val));
      }
    }
  };

  useEffect(() => {
    setInputValue(value !== undefined && value !== null ? String(value) : "");
  }, [value]);

  const formatted =
    inputValue !== "" ? Number(inputValue).toLocaleString("vi-VN") : "";

  return (
    <div>
      <input
        type="text"
        className="form-control height32"
        value={inputValue}
        onChange={handleChange}
        placeholder={placeholder || "Nhập số tiền"}
      />
      {formatted && <span className="text-muted">{formatted} đ</span>}
    </div>
  );
}
